import React from 'react';
import structure from "../images/cpct_structure.png"

const Uongozi = () => {
    const leaders = [
        {
            id: 1,
            name: "Rev. Vernon Fernandez",
            position: "Mwenyekiti",
            denomination: "Agape Life Church",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/IMG_9952.webp?alt=media&token=336a7e28-ef65-424b-af34-ecfe235c9ebc"
        },
        {
            id: 3,
            name: "Ask. Eliudi Isangya",
            position: "Makamu Mwenyekiti",
            denomination: "International Evangelism Church",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9953.jpg?alt=media&token=b9e807c4-d29c-452b-980e-d7d400676b51"
        },
        {
            id: 2,
            name: "Mch. Dr. Baraka E. Kihoza",
            denomination: "Calvary Assemblies of God",
            position: "Katibu Mkuu",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9958.jpg?alt=media&token=2a9d80c8-6177-4858-b1d3-f5988381044f"
        },
        {
            id: 9,
            name: "Ask. Dr. Bruno Mwakibolwa",
            denomination: "Mito ya Baraka Church",
            position: "Mjumbe",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9954.jpg?alt=media&token=1137246b-257d-41c3-a0b3-16db8cb50345"
        },
        {
            id: 7,
            name: "Ask. Godwin Yona Chimqisi",
            denomination: "Tabernacle Assemblies of God Tanzania",
            position: "Mjumbe",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9955.jpg?alt=media&token=b8b9b50f-19a9-447c-a112-15301ed70d9d"
        },

        {
            id: 5,
            name: "Gladness Clement Lema",
            position: "Katibu Muhtasi",
            denomination: "",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9959.jpg?alt=media&token=850b51ca-2854-4996-930a-8d7f86ab2e57"
        },

        {
            id: 8,
            name: "Mch. Stephano Bahati Maige",
            position: "Mtunza Hazina",
            denomination: "",
            image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9960.jpg?alt=media&token=ce745ff4-33b6-4ff5-bef8-5b6960218cc9"
        },

        // {
        //     id: 4,
        //     name: "-",
        //     position: "-",
        //     image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9961.jpg?alt=media&token=3c9995da-a1e2-4d3b-be9d-5092903cf0db"
        // },
        //
        // {
        //     id: 6,
        //     name: "-",
        //     position: "-",
        //     image: "https://firebasestorage.googleapis.com/v0/b/the-cpct.firebasestorage.app/o/viongozi%2FIMG_9957.jpg?alt=media&token=f70031c1-d7c7-4acc-9173-a6cd5f8b0bef"
        // },
    ];

    return (
        <div className="flex flex-col min-h-screen font-display max-w-5xl text-text-light dark:text-text-dark">

            <main className="flex-grow">
                <section className="py-4">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8">

                        <div className="bg-white dark:bg-gray-800  rounded-2xl shadow-xl p-8 mb-8">
                            <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Muundo wa Uongozi na Utawala</h2>
                            <div className={"text-center w-full"}>
                                Muundo wa uongozi wa CPCT utakuwa kama ifuatavyo na inavyoonekana katika mchoro ufuatao:
                            </div>
                            <br></br>
                            <img className={"mx-auto"} src={structure} alt={"Muundo wa Utawala"}/>
                        </div>


                        <div className={'bg-white dark:bg-gray-800  rounded-2xl shadow-xl p-8 mb-8'}>
                            <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Viongozi wa Kitaifa</h2>
                            <div className="grid mt-4 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                                {leaders.map((leader) => (
                                    <div key={leader.id} className="group text-center">
                                        <div className="relative w-full aspect-square overflow-hidden rounded-3xl">
                                            <img
                                                alt={leader.name}
                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                                src={leader.image}
                                            />
                                            <div
                                                className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                        </div>
                                        <div className="mt-4">
                                            <h3 className="text-base font-bold"
                                                style={{lineHeight: '1.1'}}>{leader.name}</h3>
                                            <p className="text-gray-600 text-sm ">{leader.denomination}</p>
                                            <hr className="border-t border-gray-200 my-1"/>
                                            <p className="text-sky-800 font-semibold text-sm ">{leader.position}</p>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>


                        <div className={'flex flex-col lg:flex-row lg:gap-8'}>
                            <div className="bg-white  dark:bg-gray-800 text-lg rounded-2xl shadow-xl p-8 mb-12">
                                <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Uanachama</h2>

                                <div className="md:flex gap-6">
                                    <div className={'flex flex-col flex-1 gap-3'}>
                                        <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                            <div
                                                className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                                <span className="text-white dark:text-blue-400 font-bold">i</span>
                                            </div>
                                            <p className="">Uanachama utakuwa wazi kwa madhehebu ya kipentekoste,
                                                huduma, na mashirika yenye imani ya kipentekoste yaliyosajiliwa
                                                serikalini kwa mujibu wa Sheria za nchi, na yanayokubaliana na kukidhi
                                                vigezo na masharti ya Katiba hii. </p>
                                        </div>
                                        <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                            <div
                                                className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-green-800 rounded-full flex items-center justify-center">
                                                <span className="text-white dark:text-green-400 font-bold">ii</span>
                                            </div>
                                            <p className="text-gray-700 dark:text-gray-300">Wanachama wataorodheshwa
                                                katika rejesta maalumu ya wanachama itakayotunzwa katika ofisi ya Katibu
                                                Mkuu na itakuwa wazi kwa ukaguzi wa umma katika siku zote za kazi masaa
                                                ya kazi. Rejesta ya wanachama itakuwepo pia kwa njia ya kidijitali.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white  dark:bg-gray-800 text-lg rounded-2xl shadow-xl p-8 mb-12">
                                <h2 className="text-3xl text-center font-bold text-gray-900 dark:text-white mb-8">Aina za Wanachama</h2>

                                <div className="md:flex gap-6">
                                    <div className={'flex flex-col flex-1 gap-3'}>
                                        <div className="flex items-start gap-4 rounded-lg dark:bg-blue-900/20">
                                            <div
                                                className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-blue-800 rounded-full flex items-center justify-center">
                                                <span className="text-white dark:text-blue-400 font-bold">i</span>
                                            </div>
                                            <p className="">Mwanachama Kamili Mwanachama kamili ni mwanachama aliyekidhi
                                                masharti ya uanachama yaliyoainishwa katika Katiba na ambaye ana haki
                                                zote za mwanachama. </p>
                                        </div>
                                        <div className="flex items-start gap-4 rounded-lg  dark:bg-green-900/20">
                                            <div
                                                className="flex-shrink-0 w-8 h-8 bg-sky-700 dark:bg-green-800 rounded-full flex items-center justify-center">
                                                <span className="text-white dark:text-green-400 font-bold">ii</span>
                                            </div>
                                            <p className="text-gray-700 dark:text-gray-300">Mwanachama Mshirika
                                                Mwanachama mshirika ni huduma ya kipentekoste isiyo na makanisa
                                                inayoyasimamia, au shirika lisilo la kiserikali lililoomba na kupatiwa
                                                uanachama kwa mujibu wa Katiba na ambaye hana haki ya kupiga au kupigiwa
                                                kura.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Kuomba Uanachama */}
                        <div className="bg-amber-100 text-lg dark:bg-gray-800 rounded-2xl shadow-xl p-8">
                            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">Kuomba Uanachama</h2>
                            <div className="gap-6 md:flex">
                                <div className={"flex flex-1 flex-col gap-4"}>
                                    <p>Utaratibu wa kuomba uanachama wa CPCT utakuwa kama ifuatavyo:</p>
                                    <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                        <div
                                            className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                            <span className="text-amber-100">i</span>
                                        </div>
                                        <p>Mwombaji atajaza fomu ya maombi ya uanachama na kuiwasilisha kwenye Kamati Tendaji ya wilaya kwa ajili ya uhakiki, kujadiliwa na kuyatolea mapendekezo.</p>
                                    </div>

                                    <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                        <div
                                            className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                            <span className="text-amber-100">ii</span>
                                        </div>
                                        <p>Kamati Tendaji ya wilaya itawasilisha mapendekezo kwa Kamati Tendaji ya mkoa kwa ajili ya kuthibitisha uhakiki wa 6.2(i) hapa juu, na kuyatolea mapendekezo.</p>
                                    </div>

                                    <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                        <div
                                            className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                            <span className="text-amber-100 ">iii</span>
                                        </div>
                                        <p>Kamati Tendaji ya mkoa itawasilisha mapendekezo kwa Kamati Tendaji ya Taifa kwa ajili ya kupitiwa na kutolewa uamuzi.</p>
                                    </div>

                                    <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                        <div
                                            className="flex-shrink-0 w-7 h-7 bg-amber-600 rounded-full flex items-center justify-center">
                                            <span className="text-amber-100 text-md">iv</span>
                                        </div>
                                        <div>
                                            Maombi ya uanachama lazima yaambatanishwe na nyaraka na taarifa zifuatazo:
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">a.</span>
                                                </div>
                                                <p>Katiba ya madhehebu iliyopitishwa na Msajili wa Jumuiya</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center">
                                                    <span className=" ">b.</span>
                                                </div>
                                                <p>Cheti cha Usajili cha madhehebu, huduma, na mashirika husika</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">c.</span>
                                                </div>
                                                <p>Muhtasari wa kikao cha mwombaji kuhusu uamuzi wa kujiunga CPCT ikionesha orodha ya wajumbe waliohudhuria na waliotia saini zao halisi kwa mkono, wenye muhuri halisi wa mwombaji</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">d.</span>
                                                </div>
                                                <p>Orodha ya viongozi waliopo madarakani na wajumbe wa Bodi ya wadhamini waliosajiliwa au waliopendekezwa kusajiliwa</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">e.</span>
                                                </div>
                                                <p>Muundo wa Uongozi na Anuani ya makazi yalipo Makao Makuu ya mwombaji</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">f.</span>
                                                </div>
                                                <p>Historia fupi ya mwombaji husika na wasifu wa viongozi waandamizi</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">g.</span>
                                                </div>
                                                <p>Barua ya utambulisho kutoka kwa mwenyekiti wa CPCT wa mkoa yalipo Makao Makuu ya mwombaji, 10</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">h.</span>
                                                </div>
                                                <p>Fomu ya ukiri wa kutoshirikiana na madhehebu au huduma zinazohatarisha Upentekoste</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">i.</span>
                                                </div>
                                                <p>Fomu ya mdhamini ambaye ni Askofu Mkuu mmojawapo wa madhehebu mwanachama, na</p>
                                            </div>
                                            <div className="text-gray-700 dark:text-gray-300 flex gap-3">
                                                <div
                                                     className="flex-shrink-0 w-6 h-6  rounded-full flex items-center justify-center">
                                                    <span className=" ">j.</span>
                                                </div>
                                                <p>j.Ushahidi wa malipo ya ada ya maombi ya uanachama.</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                    <br></br>
                    <br></br>



                </section>
            </main>

        </div>
    );
};

export default Uongozi;